<h1 class="page-header"><i class="fa fa-bolt" aria-hidden="true"></i> TRIGGERS</h1>
<div class="container-fluid">	
		<div class="page-button">
		<button id="options" (click)="onCreate()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em> CREATE TRIGGER</button>
		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
			<ul class="dropdown-menu">
				<li (click)="onEdit()" [class.disabled]="!isSingleSelection()"><a><em class="fa fa-pencil"></em> EDIT</a></li>
				<li (click)="onEdit()" [class.disabled]="!isSingleSelection()"><a><em class="fa fa-clone"></em> DUPLICATE</a></li>
				<li (click)="onDelete()" [class.disabled]="isEmptySelection()"><a><em class="fa fa-remove"></em> DELETE</a></li>
				<li (click)="onGenerate()" [class.disabled]="!isSingleSelection()"><a><em class="fa fa-bolt"></em> GENERATE </a></li>
				<li class="divider"></li>
				<li (click)="onAddGroups()" [class.disabled]="isEmptySelection()"><a><em class="fa fa-plus"></em> ADD TO GROUP</a></li>
				<li (click)="onRemoveGroup()" [class.disabled]="isEmptySelection()"><a><em class="fa fa-remove"></em> REMOVE FROM GROUP</a></li>
				<li><a><em class="fa fa-pencil"></em> MANAGE GROUPS</a></li>
			</ul>
		</div>
	</div>

	<!--  Actions -->
	<table class="table tablesorter tablesorter-default table-hover" data-toggle="table" data-id-field="userid" role="grid">
		<thead>
			<tr role="row" class="tablesorter-headerRow">
				<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted table-checkbox" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort" style="user-select: none;">
					<div class="tablesorter-header-inner">
						<div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [checked]="isAllSelected()" (change)="selectAll($event)"><label for="checkbox"></label></div>
					</div>
				</th>
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;" data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none" aria-label="Name: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">NAME</div>
				</th>
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;" data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none" aria-label="Name: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">Type</div>
				</th>
				
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;" data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none" aria-label="Groups: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">DESCRIPTION</div>
				</th>
			</tr>
		</thead>
		<tbody aria-live="polite" aria-relevant="all">
			<ng-container *ngFor="let eventUI of events">
				<tr class="" role="row">
					<td><div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [(ngModel)]="eventUI.selected"><label for="checkbox"></label></div></td>
					<td (click)="editEvent(eventUI.event.id)">
						<span *ngIf="eventUI.event.glyph != null"><i class="fa" [ngClass]="eventUI.event.glyph"></i></span>&nbsp; {{eventUI.event.name}}
					</td>
					<td (click)="editEvent(eventUI.event.id)">{{eventUI.event.type}}</td>
					<td (click)="editEvent(eventUI.event.id)">{{eventUI.event.description}}</td>
				</tr>
			</ng-container>
		</tbody>		
	</table>
</div>

<app-event-dialog #eventDialog 
	[event]="event"
	(createOrUpdateEvent)="createOrUpdateEvent()"></app-event-dialog>
<app-event-creation-dialog #eventCreationDialog 
	[event]="event"></app-event-creation-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog
	(confirmEvent)="deleteEvents()"></app-confirm-delete-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeFromGroup($event)"></app-remove-from-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
	